import { render } from "./OtiSquareAdmin.vue?vue&type=template&id=1827d2f0&scoped=true"
import script from "./OtiSquareAdmin.vue?vue&type=script&lang=js"
export * from "./OtiSquareAdmin.vue?vue&type=script&lang=js"

import "./OtiSquareAdmin.vue?vue&type=style&index=0&id=1827d2f0&lang=scss&scoped=true"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1827d2f0"]])

export default __exports__